"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  name: 'RLTableHead',
  inject: ['opts', 'slots', 'componentsOverride'],
  render: function render() {
    return this.$scopedSlots["default"]({
      opts: this.opts(),
      slots: this.slots(),
      override: this.componentsOverride.tableHead
    });
  }
};
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2-premium/compiled/components/renderless/RLTableHead.js
// module id = 850
// module chunks = 0